import { NeedDto } from '@act/shared/data-transfer-objects';
import { needsSelectors } from 'redux/slices/needs.slice';
import HistoryEntry from './HistoryEntry';

interface NeedHistoryProps {
  need: NeedDto;
  detailMode?: boolean;
  editMode?: boolean;
}

const NeedHistory = ({ need, detailMode, editMode }: NeedHistoryProps) => {
  const history = needsSelectors.useSelectNeedHistoryEntriesByIds(
    need.historyEntryIds
  );

  return (
    <div className="need-history">
      {history.map(h => (
        <div key={`history-${h.id}`} className="entry">
          <HistoryEntry
            need={need}
            historyEntry={h}
            detailMode={detailMode}
            editMode={editMode}
          />
        </div>
      ))}
    </div>
  );
};

export default NeedHistory;
